<template>
  <div v-html="svg" v-if="svg" :class="{ 'has-fill': color !== 'unset' }"></div>
</template>

<script lang="ts" setup>
const { icon, svgMaxWidth, svgMaxHeight, color } = defineProps({
  icon: String,
  svgMaxWidth: { type: [Number, String], default: 16 },
  svgMaxHeight: { type: [Number, String], default: 16 },
  width: { type: [Number, String], default: 36 },
  height: { type: [Number, String], default: 36 },
  color: { type: String, default: 'unset' },
})

const modules = import.meta.glob('/src/assets/icons/*.svg', {
  query: '?raw',
  import: 'default',
  eager: false,
})

const svg = ref<string | null>(null)

watchEffect(async () => {
  if (icon && modules[`/src/assets/icons/${icon}.svg`]) {
    const mod = await modules[`/src/assets/icons/${icon}.svg`]()
    svg.value = mod
  } else {
    svg.value = null
  }
})

const maxWidth = computed(() => `${svgMaxWidth}px`)
const maxHeight = computed(() => `${svgMaxHeight}px`)
const fillColor = computed(() => (color !== 'unset' ? color : 'unset'))
</script>
<style scoped>
div :deep(svg) {
  max-width: v-bind(maxWidth);
  max-height: v-bind(maxHeight);
}

div.has-fill :deep(svg) {
  fill: v-bind(fillColor);
}
</style>
